
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/socials",
      function () {
        return require("private-next-pages/socials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/socials"])
      });
    }
  